// @flow
import * as React from 'react';
import { withLeaflet } from 'react-leaflet';
import type { LeafletContext } from 'react-leaflet/lib/types';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import UseHighlightPoint from 'esm-web-pro/hooks/useHighlightPoint';


type Props = {
    point: { coordinates: { coordinates: [number, number] } },
    editor: BaseEditor,
    children: (handleView: Function) => React.Node,

    leaflet: LeafletContext,
};

const MapFiber = (props: Props) => {
    const {
        point, editor, children, leaflet: { map },
    } = props;

    const {
        coordinates: { coordinates },
        sequence, type, alias,
    } = point;

    const handleView = () => {
        if (map) {
            map.highlightedGeometry = {
                bounds: null, center: [coordinates[1], coordinates[0]],
            };
            map.panTo([coordinates[1], coordinates[0]]);
        }
    };

    React.useEffect(() => {
        let number = sequence;
        if (type === 'pop' && alias) {
            number = alias;
        }
        editor.registerLoadingCallback(UseHighlightPoint(coordinates, number));
        handleView();
        editor.reloadFeatures();
        return () => {
            editor.unregisterAllLoadingCallback();
        };
    }, []);

    return children(handleView);
};

export default withLeaflet(MapFiber);
